import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=47f0be1d&scoped=true"
import script from "./activity-list.vue?vue&type=script&lang=js"
export * from "./activity-list.vue?vue&type=script&lang=js"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=47f0be1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0be1d",
  null
  
)

export default component.exports